var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    staticClass: "drawer-body",
    attrs: {
      "width": _vm.AddNewSalesRecipeDrawerOpened ? 1000 : 800,
      "title": _vm.openedSales && _vm.openedSales.customer.name
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('Modal', {
    attrs: {
      "title": "删除配方"
    },
    on: {
      "on-ok": _vm.confirmDelRecipe
    },
    model: {
      value: _vm.delRecipeModal,
      callback: function ($$v) {
        _vm.delRecipeModal = $$v;
      },
      expression: "delRecipeModal"
    }
  }, [_c('p', [_vm._v("你确认删除此配方吗？")])]), _vm.AddNewSalesRecipeDrawerOpened ? _c('AddNewSalesRecipeDrawer', {
    ref: "AddNewSalesRecipeDrawer",
    on: {
      "closeDrawer": _vm.closeAddRecipeDrawer
    }
  }) : _c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "info-data"
  }, [_c('div', {
    staticClass: "sec-title"
  }, [_c('h2', [_vm._v(" 产品：" + _vm._s(_vm.openedSales && _vm.openedSales.material.model + _vm.openedSales.material.name) + " ")])]), _c('Button', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.createNewRecipe
    }
  }, [_vm._v("创建配方")]), _c('div', {
    staticClass: "sec-title"
  }, [_vm._v("生产配方")]), _vm.prodRecipe ? _c('RecipeCard', {
    attrs: {
      "recipe": _vm.prodRecipe,
      "active": _vm.prodRecipe._id === _vm.selectedRecipe._id
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.recipedClicked(_vm.prodRecipe);
      }
    }
  }) : _c('Alert', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("暂无生产配方")]), _c('div', {
    staticClass: "sec-title"
  }, [_vm._v("配方列表")]), _vm.recipeSalesList.length <= 0 ? _c('Alert', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("暂无配方")]) : _vm._l(_vm.recipeSalesList, function (r) {
    return _c('RecipeCard', {
      key: r._id,
      attrs: {
        "recipe": r,
        "active": r._id === _vm.selectedRecipe._id
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.recipedClicked(r);
        }
      }
    });
  })], 2), _c('div', {
    staticClass: "recipe-data"
  }, [_vm.selectedRecipe._id ? _c('div', [_c('div', {
    staticClass: "recipe-top"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.selectedRecipe.name))])]), _c('div', {
    staticClass: "action-button"
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "ghost": "",
      "size": "small"
    },
    on: {
      "click": _vm.calcRecipeCostMethod
    }
  }, [_vm._v("计算成本")]), _c('Button', {
    attrs: {
      "type": "info",
      "ghost": "",
      "size": "small"
    },
    on: {
      "click": _vm.setProdRecipeSalesMethod
    }
  }, [_vm._v("设为生产配方")]), _c('Button', {
    attrs: {
      "type": "info",
      "ghost": "",
      "size": "small"
    },
    on: {
      "click": _vm.copyRecipe
    }
  }, [_vm._v("复制配方")]), _c('Button', {
    attrs: {
      "type": "error",
      "ghost": "",
      "size": "small"
    },
    on: {
      "click": _vm.clickDelRecipeModal
    }
  }, [_vm._v("删除")])], 1)]), _c('div', {
    staticClass: "recipe-info"
  }, [_c('div', [_c('div', [_vm._v("配方编号: #" + _vm._s(_vm.selectedRecipe.NoId))]), _c('div', [_vm._v("审核情况: " + _vm._s(_vm.statusToText(_vm.selectedRecipe.status)))])]), _c('div', [_vm.selectedRecipe.createdBy ? _c('div', [_vm._v(" 创建人: " + _vm._s(_vm.selectedRecipe.createdBy.name) + " ")]) : _vm._e()]), _c('div', [_vm._v("审核时间: " + _vm._s(_vm.dayjs(_vm.selectedRecipe.createdAt)))])]), _c('RecipeTable', {
    ref: "RecipeTable"
  })], 1) : _c('Alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("暂无配方")])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }